import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { FiltersService } from '../../../../services/filters.service';
import { FormBuilder, FormArray } from '@angular/forms';
import { PropertiesService } from 'src/app/services/properties.service';

@Component({
  selector: 'app-add-propertie',
  templateUrl: './add-propertie.component.html',
  styleUrls: ['./add-propertie.component.css'],
  standalone: false
})
export class AddPropertieComponent implements OnInit {
  @ViewChild('f') f!: NgForm;

  // === Estado general ===
  loading = false;
  error = false;
  mensajeErrorIA = "";
  msjError = "";

  propiedad: any = {};
  direccion: any = {
    calle: '',
    numero: '',
    piso: '',
    depto: '',
    callesEntre: '',
    lat: null,
    lng: null
  };

  // === Catálogos ===
  localidades: any[] = [];
  tipoPropiedades: any[] = [];
  tipoOperaciones: any[] = [];
  tipoMonedas: any[] = [];
  caracteristicasPropiedad: any[] = [];

  // === Formularios dinámicos ===
  productFormGroupCarct: FormArray = this.formBuilder.array([]);
  productFormGroupPrecio: FormArray = this.formBuilder.array([]);

  // === IDs especiales ===
  aptoCreditoId: number | null = null;

  constructor(
    private router: Router,
    private filtersServ: FiltersService,
    public formBuilder: FormBuilder,
    private propertiesService: PropertiesService
  ) { }

  ngOnInit() {
    this.getLocalidades();
    this.getTipoPro();
    this.getTipoOpe();
    this.getTipoMoneda();
    this.getCaractProp();
  }

  // ==== Helpers ====
  public isTruthy(v: any): boolean {
    if (typeof v === 'boolean') return v;
    if (v === 1 || v === '1') return true;
    if (v === 0 || v === '0') return false;
    if (typeof v === 'string') {
      const s = v.trim().toLowerCase();
      return s === 'true' || s === 'si' || s === 'sí';
    }
    return !!v;
  }

  updateLatLng(coords: { lat: number; lng: number }) {
    this.direccion.lat = coords.lat;
    this.direccion.lng = coords.lng;
  }

  // ==== CRUD ====
  CrearPropiedad(form: NgForm) {
    const caractList: any[] = [];
    if (this.productFormGroupCarct?.value?.length) {
      this.productFormGroupCarct.value.forEach(item => {
        caractList.push({
          caracteristicasPropiedadId: item.caractPropId,
          valor: item.caractPropValor
        });
      });
    }

    const propiedadNew = {
      descripcionCorta: form.controls.descripcionCorta?.value,
      descripcionLarga: form.controls.descripcionLarga?.value,
      infoInterna: form.controls.infoInterna?.value,
      valorPropiedad: form.controls.precio?.value,
      tipoMoneda: form.controls.tipoMoneda?.value,
      caracteristicasPropiedadPropiedadValor: caractList,
      domicilio: {
        calle: form.controls.calle?.value,
        numero: form.controls.numero?.value,
        piso: form.controls.piso?.value,
        departamento: form.controls.depto?.value,
        callesEntre: form.controls.callesEntre?.value,
        barrioId: 1,
        lat: this.direccion.lat,
        lng: this.direccion.lng
      },
      videoUrl: form.controls.videoUrl?.value,
      propiedadTipoOperacion: [
        { tipoOperacionId: form.controls.tipoOp?.value }
      ],
      propiedadTipoPropiedad: [
        { tipoPropiedadId: form.controls.tipoPro?.value }
      ]
    };
    this.propertiesService.postPropiedad(propiedadNew).subscribe({
      next: () => this.router.navigate(['/admin/principal']),
      error: (err) => console.log(err)
    });
  }

  back() {
    this.router.navigate(['/admin/principal']);
  }

  // ==== Dinámico Características ====
  loadCaracteristicas() {
    this.productFormGroupCarct = this.formBuilder.array([]);
  }

  deleteCaractetistica(i: number) {
    this.productFormGroupCarct.removeAt(i);
  }
  addCaractetistica() {
    this.productFormGroupCarct.push(
      this.formBuilder.group({
        caractPropId: '',
        caractPropValor: ''
      })
    );
  }

  // ==== Catálogos ====
  getLocalidades() {
    this.filtersServ.getLocalidad().subscribe({
      next: (data: any[]) => {
        this.localidades = data;
        this.localidades.unshift({ descripcion: 'Ciudad', id: '' });
      },
      error: (err) => console.log(err)
    });
  }

  getTipoPro() {
    this.filtersServ.getTipoPro().subscribe({
      next: (data: any[]) => {
        this.tipoPropiedades = data;
        this.tipoPropiedades.unshift({ descripcion: 'Tipo propiedad', id: '' });
      },
      error: (err) => console.log(err)
    });
  }

  getTipoOpe() {
    this.filtersServ.getTipoOpe().subscribe({
      next: (data: any[]) => {
        this.tipoOperaciones = data;
        this.tipoOperaciones.unshift({ descripcion: 'Tipo Operación', id: '' });
      },
      error: (err) => console.log(err)
    });
  }

  getCaractProp() {
    this.filtersServ.getCaracteristicasProp().subscribe({
      next: (data: any[]) => {
        const apto = data.find(c => (c.descripcion || '').toLowerCase().includes('apto'));
        this.aptoCreditoId = apto?.id ?? null;

        this.caracteristicasPropiedad = data;
        this.caracteristicasPropiedad.unshift({ descripcion: 'Caracteristica', id: '' });
      },
      error: (err) => console.log(err)
    });
  }

  getTipoMoneda() {
    this.filtersServ.getTipoMoneda().subscribe({
      next: (data: any[]) => {
        this.tipoMonedas = data;
        this.tipoMonedas.unshift({ descripcion: 'Moneda', id: '' });
      },
      error: (err) => console.log(err)
    });
  }

  // ==== IA ====
  confirmarIA(f: any) {
    const ok = confirm('⚠️ Generar la descripción con IA tiene un costo. ¿Está seguro?');
    if (ok) this.GenerarDescripcionIA(f);
  }

  GenerarDescripcionIA(form: NgForm) {
    this.loading = true;
    this.error = false;
    this.msjError = '';

    const caractListText: string[] = [];

    if (this.productFormGroupCarct?.value?.length) {
      this.productFormGroupCarct.value.forEach(item => {
        const cat = this.caracteristicasPropiedad.find(c => c.id === item.caractPropId);
        if (cat) {
          caractListText.push(`${cat.descripcion}: ${item.caractPropValor}`);
        }
      });
    }

    const tipoOperacion = this.tipoOperaciones.find(o => o.id === form.controls.tipoOp.value);
    const tipoPropiedad = this.tipoPropiedades.find(p => p.id === form.controls.tipoPro.value);
    const localidad = this.localidades.find(l => l.id === form.controls.localidad.value);

    if (tipoOperacion) caractListText.push(`Operación: ${tipoOperacion.descripcion}`);
    if (tipoPropiedad) caractListText.push(`Tipo de propiedad: ${tipoPropiedad.descripcion}`);
    if (form.controls.piso?.value) caractListText.push(`Piso: ${form.controls.piso.value}`);
    if (localidad) caractListText.push(`Ubicación: ${localidad.descripcion}`);

    const payload = {
      infoInterna: form.controls.infoInterna.value,
      caracteristicas: caractListText
    };

    this.propertiesService.generarDescripcion(payload).subscribe({
      next: (res: any) => {
        this.propiedad.descripcionCorta = res.descripcionCorta;
        this.propiedad.descripcionLarga = res.descripcionLarga;
        this.loading = false;
        this.error = false;
      },
      error: (err) => {
        this.loading = false;
        this.error = true;
        this.msjError = err?.error?.code === 'insufficient_quota'
          ? '⚠️ No tienes crédito disponible para usar IA.'
          : '❌ Ocurrió un error al generar la descripción con IA.';
        setTimeout(() => { this.msjError = ''; }, 5000);
      }
    });
  }
}
